import { Typography } from '@mui/material';

export default function TourGuidePopover(props) {
  const isStartStep = props.currentStep === 0;
  const isLastStep = props.currentStep === props.steps.length - 1;
  const content = props.steps[props.currentStep].content;

  return (
    <>
      <span className="reactour__badge">{props.currentStep + 1}</span>

      <button
        type="button"
        className="reactour__close-button"
        aria-label="Close Tour"
        onClick={() => props.setIsOpen(false)}
      >
        <svg viewBox="0 0 9.1 9.1" aria-hidden="true" role="presentation">
          <path
            fill="currentColor"
            d="M5.9 4.5l2.8-2.8c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L4.5 3.1 1.7.3C1.3-.1.7-.1.3.3c-.4.4-.4 1 0 1.4l2.8 2.8L.3 7.4c-.4.4-.4 1 0 1.4.2.2.4.3.7.3s.5-.1.7-.3L4.5 6l2.8 2.8c.3.2.5.3.8.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L5.9 4.5z"
          />
        </svg>
      </button>

      {typeof content === 'function' && content({ ...props, someOtherStuff: 'Custom Text' })}
      {typeof content === 'object' && (
        <>
          <Typography variant="subtitle1" sx={{ my: 1 }}>
            {content.title}
          </Typography>
          <Typography variant="body2">{content.description}</Typography>
        </>
      )}
      {(typeof content === 'string' || typeof content === 'number') && content}

      <div dir="ltr" className="reactour__button-wrapper">
        <button
          type="button"
          aria-label="Go to prev step"
          className="reactour__step-button"
          onClick={() => (!isStartStep ? props.setCurrentStep((s) => s - 1) : null)}
          disabled={isStartStep}
        >
          <svg viewBox="0 0 18.4 14.4">
            <path
              d="M1.4 7.2h16M7.6 1L1.4 7.2l6.2 6.2"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeMiterlimit="10"
            />
          </svg>
        </button>
        <div className="reactour__dot-wrapper">Step {props.currentStep + 1}</div>
        <button
          type="button"
          aria-label="Go to next step"
          className="reactour__step-button"
          onClick={() => (!isLastStep ? props.setCurrentStep((s) => s + 1) : null)}
          disabled={isLastStep}
        >
          <svg viewBox="0 0 18.4 14.4">
            <path
              d="M17 7.2H1M10.8 1L17 7.2l-6.2 6.2"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeMiterlimit="10"
            />
          </svg>
        </button>
      </div>
    </>
  );
}
